import { colorOptions } from '../../views/plans/components/Color/colorOptions';
import { thicknessOptions } from '../../views/plans/components/Thickness/thicknessOptions';

const initialState = {
  color: colorOptions[0], // red
  selectedThickness: thicknessOptions[1], // md
  toolbarOptionsPanel: '', // thickness | color
  cursorTooltip: '',
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'fabric_overlay/UPDATE_OVERLAY':
      return {
        ...state,
        fabricOverlay: action.fabricOverlay,
        viewer: action.viewer,
      };

    case 'fabric_overlay/UPDATE_TOOL': {
      return {
        ...state,
        activeTool: action.tool,
        toolbarOptionsPanel: '',
      };
    }

    case 'fabric_overlay/UPDATE_COLOR': {
      return {
        ...state,
        color: action.color,
      };
    }

    case 'fabric_overlay/UPDATE_THICKNESS':
      return {
        ...state,
        selectedThickness: action.thickness,
      };

    case 'fabric_overlay/SET_ACTIVE_OBJECT': {
      return {
        ...state,
        activeObject: action.object,
      };
    }

    case 'fabric_overlay/SET_TOOLBAR_OPTIONS_PANEL': {
      return {
        ...state,
        toolbarOptionsPanel: action.options_panel,
      };
    }

    case 'fabric_overlay/SET_CURSOR_TOOLTIP': {
      return {
        ...state,
        cursorTooltip: action.text,
      };
    }

    default:
      return state;
  }
}
